@if (outstandingWorkflowConnections.length > 0) {
    <adapt-styled-dashboard-element name="Active pathways"
                                    [background]="false"
                                    [nested]="true"
                                    [url]="url$ | async"
                                    [info]="activePathwaysTooltip"
                                    [linkText]="recommendedWorkflows.length === 0 ? 'View all pathways' : undefined">
        <div class="workflows">
            @for (connection of outstandingWorkflowConnections; track connection) {
                <adapt-display-workflow-card [connection]="connection"></adapt-display-workflow-card>
            }
        </div>
    </adapt-styled-dashboard-element>
}

@if (recommendedWorkflows.length > 0) {
    <adapt-styled-dashboard-element name="Up next"
                                    [background]="false"
                                    [nested]="true"
                                    [url]="url$ | async"
                                    linkText="View all pathways">
        <div class="workflows">
            @for (workflow of recommendedWorkflows; track workflow) {
                <adapt-display-workflow-card [workflow]="workflow"></adapt-display-workflow-card>
            }
        </div>
    </adapt-styled-dashboard-element>
}
